export default "__VITE_ASSET__BetkWumm__"